import React, { FC, ReactNode, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import ZonesTab from "../../../containers/zones-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useTabCount } from "../../../hooks/useCategoryTab";
import { Button } from "../../../components/button/Button";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { Filter } from "../../../models/Filter";
import { showError } from "../../../services/utilities/ServiceError";
import { getListOfSiteIdsFromFilterWithKey } from "../../../utilities/tabUtils";

const Zones: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();

    const { updateTabCount } = useTabCount({
        tableName:"Zone",
        pathToSite:"controller.site",
        categories,
        setCategories
    });

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.zones),
                    heading: translate.byKey(TranslationKeys.zones),
                    value: "",
                    id: 0,
                    count: 0,
                },
            ]);

            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    useEffect(() => {
        buildCategoriesData();
    }, []);

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [<ZonesTab onFilterChange={onFilterChange} setBusy={setBusy} categories={categories} setCategories={setCategories}></ZonesTab>];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const onFilterChange = (filters:Filter[]) => {
        const siteIds = getListOfSiteIdsFromFilterWithKey(filters,"controller.deviceImprox.site.id");
        updateTabCount(siteIds);
    }

    return (
        <>
            <ActivityFrame
                busy={busy}
                className="flex flex-grow overflow-y-hidden">
                <div id="container-tabs" className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            {
                                value: "/access-control/hardware",
                                displayName: translate.byKey(TranslationKeys.hardware),
                            },
                            {
                                value: "/access-control/hardware/zones",
                                displayName: translate.byKey(TranslationKeys.zones),
                            },
                        ]}
                        onClick={(item) => history.push(item.value)} />
                    <Tabs
                        className="bg-white"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false} >
                        {tabContent[selected]}
                        <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                            <div className="flex flex-row justify-end button-cluster">
                                <Restricted to={`add.zones.element`}>
                                    <Link
                                        to={{
                                            pathname: "/access-control/hardware/zone/",
                                        }}>
                                        <Button variant="submit" shape="rounded" id="zonesAddButton">
                                            <img
                                                src={plusIcon}
                                                className="px-2 w-8 py-1"
                                                alt="" />
                                            <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                        </Button>
                                    </Link>
                                </Restricted>
                            </div>
                        </div>
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default Zones;
